import { formatMoney } from 'accounting'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/pro-solid-svg-icons'

import {
  Box, ColouredTile, ListItem, Text,
} from '@domain-group/suit-theme'

import { statusColors } from '@functions/status'

import useCampaignQuote from '@hooks/useCampaignQuote'

import type { CampaignQuoteModel, UserModel } from '@models/types'

type LargeListProps = {
  campaignQuote: CampaignQuoteModel,
  currentUser: UserModel,
  isCampaignManager: boolean,
  href: string | undefined,
}

const LargeList = (props: LargeListProps) => {
  const {
    campaignQuote,
    campaignQuote: {
      id, priority_campaign_user_ids: priorityUserIds, title, total,
    },
    currentUser,
    isCampaignManager,
    href,
  } = props

  const { campaign, status } = useCampaignQuote(campaignQuote)
  // @ts-expect-error TS2339
  const { address, suburb_name } = campaign

  // @ts-expect-error TS2339
  const { title: statusTitle } = status

  // @ts-expect-error TS7053
  const tileColor = statusColors[status.key]
  const totalFormatted = formatMoney(total)

  const isPriorityCampaignForCurrentUser = priorityUserIds?.includes(currentUser.id)

  return (
    <ListItem
      boxProps={{ as: 'a', borderBottom: '1px solid', padding: 'large' }}
      href={href}
      showAngleIcon
    >
      <Box alignItems="center" justifyContent="center" marginRight="large" width={84}>
        <ColouredTile boxProps={{ textAlign: 'center' }} color={tileColor}>
          {statusTitle || 'Pending'}
        </ColouredTile>
      </Box>

      <Box justifyContent="center" flexDirection="column">
        <Text fontSize="small">
          {isCampaignManager ? `${title}` : `${address}, ${suburb_name}`}
        </Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          {isCampaignManager ? `Quote #${id} - ${totalFormatted}` : `${title} - ${totalFormatted}`}
        </Text>
      </Box>

      <Box justifyContent="flex-end" alignItems="center">
        {isPriorityCampaignForCurrentUser && !isCampaignManager && (
          <Text
            color="blue"
            marginRight="small"
            fontSize="small"
          >
            <FontAwesomeIcon icon={faStar} />
          </Text>
        )}
      </Box>
    </ListItem>
  )
}

export default LargeList
